// import * as net from "../../utils/network";

import api from '../../utils/api';
import {updatedProfile} from './authActions';
import {getCourseUser} from './videoActions';

export const ACTION_BASIC_INFO_USER_UPDATE = 'ACTION_BASIC_INFO_USER_UPDATE';
export const ACTION_CONTACTS_INFO_USER_UPDATE = 'ACTION_CONTACTS_INFO_USER_UPDATE';
export const ACTION_EDUCATION_INFO_USER_UPDATE = 'ACTION_EDUCATION_INFO_USER_UPDATE';
export const ACTION_CIRCUMSTANCES_INFO_USER_UPDATE = 'ACTION_CIRCUMSTANCES_INFO_USER_UPDATE';
export const ACTION_LSAT_INFO_USER_UPDATE = 'ACTION_LSAT_INFO_USER_UPDATE';
export const ACTION_UPDATED_PROFILE = 'ACTION_UPDATED_PROFILE';
export const ACTION_UPDATED_COURSEUSER = 'ACTION_UPDATED_COURSEUSER';



// function actionBasicUserInfoLoaded(basicUserInfo) {
//     return {
//         type: ACTION_GET_INFO,
//         payload: basicUserInfo
//     };
// }
//
// CREATORS
// export function updateBasicUserInfo() {
//     return (dispatch, getState) => {
//         const {core} = getState();
//
//         net.aGet('')
//             .then(data => {
//                 dispatch(actionBasicUserInfoLoaded(data.filter((basicUserInfo) => basicUserInfo === core))); //or any other relevant condition
//             });
//     };
// }

export function updateBasicUserInfo(updates) {
    return {
        type: ACTION_BASIC_INFO_USER_UPDATE,
        payload: updates
    };
}

export function updateContactsUserInfo(updates) {
    return {
        type: ACTION_CONTACTS_INFO_USER_UPDATE,
        payload: updates
    };
}

export function updateEducationUserInfo(updates) {
    return {
        type: ACTION_EDUCATION_INFO_USER_UPDATE,
        payload: updates
    };
}

export function updateCircumstancesUserInfo(updates) {
    return {
        type: ACTION_CIRCUMSTANCES_INFO_USER_UPDATE,
        payload: updates
    };
}

export function updateLsatUserInfo(updates) {
    return {
        type: ACTION_LSAT_INFO_USER_UPDATE,
        payload: updates
    };
}

export function updateProfile(profile, token) {
    return (dispatch) => {
        api.updateProfile(profile, token, res => {
            if(res.status === 200){
                dispatch(updatedProfile(res.data));
                dispatch(getCourseUser(profile.id, token));
                
            }
        })
    }
}

/*

function updatedCourseUser(cu){
    return {
        type: ACTION_UPDATED_COURSEUSER,
        payload: cu
    }
}

*/

export function updateCourseUser(profile, cu, token) {
    return (dispatch) => {
        api.updateCourseUser(cu, token, res => {
            if(res.status === 200){
                api.updateProfile(profile, token, res2 => {
                    if(res2.status === 200){
                        
                        dispatch(updatedProfile(res2.data));
                        dispatch(getCourseUser(profile.id, token));
                        
                    }
                })
                
                //dispatch(updateProfile(profile, token));
                
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/infoActions.js